import { PLAN_COSTS } from '@Saral-Influencer-Marketing/saral-utils/src/constants';

export const getShortFormForPlanInterval = (type) => {
  if (!type) {
    return 'mo';
  }
  if (type.includes('month')) {
    return 'mo';
  } else if (type.includes('quart')) {
    return 'quarter';
  } else if (type.includes('annual')) {
    return 'year';
  }
};

export const getPlanCostFromRatna = (planType, ratna) => {
  if (!ratna) {
    return null;
  }
  ratna = Number(ratna);
  const planRates = PLAN_COSTS[planType];
  if (planRates && ratna in planRates) {
    return planRates[ratna];
  } else {
    return null;
  }
};
export const checkIfProfileAlreadyOnboarded = (profile, onboardedStages) => {
  if (onboardedStages.includes(profile?.relationshipStageId)) {
    return true;
  }
  return false;
};
